export enum Lang {
    Spanish = 'es',
    Catalan = 'ca',
    English = 'en',
    French = 'fr',
    German = 'de'
}
